// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD5kRuOK9yEZhJPGppoDNZeMvoF1bRfDgI",
  authDomain: "kinetix-59d01.firebaseapp.com",
  projectId: "kinetix-59d01",
  storageBucket: "kinetix-59d01.appspot.com",
  messagingSenderId: "296073547452",
  appId: "1:296073547452:web:5263a671d54cdfcebecab9",
  measurementId: "G-ZCM28TH5LM",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
